module.exports = __webpack_public_path__ + "img/8-kooien.c0c68327.jpg";